import React from 'react';
import RemainingKPIRouter from './RemainingKPIRouter';

export default function RemainingKPIPage() {
  return <RemainingKPIRouter />;
}
